export class Composant {
    constructor(
        public idComposant?: number,
        public code?: string,
        public llComposant?: string,
        public lcComposant?: string,
        public typeComposantId?: number,
        public periode?: number,
        public grade?: number
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/grhum/composant.model.ts